import * as PrimitiveDialog from '@radix-ui/react-dialog'

import { SideSheetContent } from './components/side-sheet-content'
import { SideSheetHeader } from './components/side-sheet-header'

// Root
type SideSheetProps = React.ComponentPropsWithRef<typeof PrimitiveDialog.Root>

const SideSheetRoot = (props: SideSheetProps) => (
  <PrimitiveDialog.Root {...props} data-scope="side-sheet" />
)

// Trigger
const SideSheetTrigger = (
  props: React.ComponentPropsWithRef<typeof PrimitiveDialog.Trigger>
) => <PrimitiveDialog.Trigger {...props} data-scope="side-sheet-trigger" />

// Close
const SideSheetClose = (
  props: React.ComponentPropsWithRef<typeof PrimitiveDialog.Close>
) => <PrimitiveDialog.Close {...props} data-scope="side-sheet-close" />

// Composition
const SideSheet = {
  Root: SideSheetRoot,
  Trigger: SideSheetTrigger,
  Content: SideSheetContent,
  Header: SideSheetHeader,
  Close: SideSheetClose,
}

export { SideSheet }
export type { SideSheetProps }
